export default __webpack_public_path__ + "static/media/227.26ea96a7.jpg";